module.exports = __webpack_public_path__ + "static/media/player.7d9278ed.jpg";